const handleMessage = (message: string, parameters: any[]): string => {
    let handledMessage: string = message;

    parameters.forEach((param, index) => {
        handledMessage = handledMessage.replace(`{${index}}`, String(param));
    });

    return handledMessage;
};


export { handleMessage };